import * as React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { safeLazy } from '@avantstay/backoffice-core'

import { AskRemyLauncher } from '@new/__global/components/AskRemy'
import { GlobalGlossarySidebar } from '@new/__global/components/GlobalGlossarySidebar'
import { Layout } from '@new/__global/components/Layout'

import { ROUTES } from '@routes'
import history from '@utils/history'
import { withErrorBoundary } from '@utils/withErrorBoundary'

const AccountingScreen = withErrorBoundary(safeLazy(() => import('@screens/Accounting.screen')))
const Booking = withErrorBoundary(safeLazy(() => import('@screens/Booking.screen')))
const Bookings = withErrorBoundary(safeLazy(() => import('@screens/Bookings.screen')))
const Dashboard = withErrorBoundary(safeLazy(() => import('@screens/Dashboard.screen')))
const ErrorScreen = safeLazy(() => import('@screens/Error.screen'))
const FinanceScreen = React.lazy(() => import('@screens/Finance.screen'))
const HelpScreen = withErrorBoundary(safeLazy(() => import('@screens/Help.screen')))
const Hotel = withErrorBoundary(safeLazy(() => import('@screens/Hotel.screen')))
const Buildings = withErrorBoundary(safeLazy(() => import('@screens/Buildings.screen')))
const ListingDraft = withErrorBoundary(safeLazy(() => import('@screens/ListingDraft.screen')))
const Marketing = withErrorBoundary(safeLazy(() => import('@screens/Marketing.screen')))
const Markets = withErrorBoundary(safeLazy(() => import('@screens/Markets.screen')))
const Operations = withErrorBoundary(safeLazy(() => import('@screens/Operations.screen')))
const PeopleScreen = withErrorBoundary(safeLazy(() => import('@screens/People.screen')))
const Properties = withErrorBoundary(safeLazy(() => import('@screens/Properties.screen')))
const Property = withErrorBoundary(safeLazy(() => import('@screens/Property.screen')))
const RatingsScreen = withErrorBoundary(safeLazy(() => import('@/screens/Ratings.screen')))
const ScheduledSms = withErrorBoundary(safeLazy(() => import('@/screens/ScheduledSms.screen')))
const Settings = withErrorBoundary(safeLazy(() => import('@screens/Settings.screen')))
const GroupsEvents = withErrorBoundary(safeLazy(() => import('@screens/GroupsEvents.screen')))

const isPathnameRegion = history.location.pathname.includes('/region')
const isPathnameRegions = history.location.pathname.includes('/regions')

export const MainScreensSwitch = () => {
  return (
    <>
      <Layout>
        <Switch>
          <Route path={ROUTES.revenue.path} exact={false} component={FinanceScreen} />
          <Route {...ROUTES.hotelTapeChart} component={Bookings} />
          <Route {...ROUTES.fastTapeChart} component={Bookings} />
          <Route {...ROUTES.bookings} component={Bookings} />
          <Route path={ROUTES.groupsEvents.path} component={GroupsEvents} />
          <Route {...ROUTES.bookingServicesRequests} component={Bookings} />
          <Route {...ROUTES.idVerification} component={Bookings} />
          <Route {...ROUTES.bookingRefundRequests} component={Bookings} />
          <Route {...ROUTES.bookingConflicts} component={Bookings} />
          <Route {...ROUTES.finance} component={AccountingScreen} />
          <Route {...ROUTES.dashboard} component={Dashboard} />
          <Redirect from="/properties/unit_economics" to={ROUTES.unitEconomics.path} />
          <Route {...ROUTES.properties} component={Properties} />
          <Route {...ROUTES.property} component={Property} />
          <Route {...ROUTES.buildings} component={Buildings} />
          <Route {...ROUTES.buildingsList} component={Buildings} />
          <Route {...ROUTES.performanceHub} component={Buildings} />
          <Route {...ROUTES.hotel} component={Hotel} />
          <Route {...ROUTES.marketing} component={Marketing} />
          <Route {...ROUTES.settings} component={Settings} />
          <Route {...ROUTES.booking} component={Booking} />
          <Route {...ROUTES.error} component={ErrorScreen} />
          <Route {...ROUTES.help} component={HelpScreen} />
          <Route {...ROUTES.people} component={PeopleScreen} />
          <Route {...ROUTES.ratings} component={RatingsScreen} />
          <Route {...ROUTES.cancelScheduledSms} component={ScheduledSms} />
          <Route {...ROUTES.operations} component={Operations} />
          <Route {...ROUTES.markets} component={Markets} />
          <Route {...ROUTES.allListingDrafts} component={ListingDraft} />
          <Route {...ROUTES.listingDraft} component={ListingDraft} />
          {/* Support old url */}
          {!isPathnameRegions && !isPathnameRegion && (
            <Redirect from="*" to={ROUTES.dashboard.path} />
          )}
          <Redirect from="/region/:id" to={ROUTES.ratingsMarketsReview.path} />
          <Redirect from="/guests" to={ROUTES.guests.path} />
        </Switch>
      </Layout>

      <GlobalGlossarySidebar />

      <AskRemyLauncher />
    </>
  )
}
